import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import useQueryParams from 'hooks/useQueryParams';
import { SortingButton } from 'router/subrouters/DataRoom/components/SortingButton';
import { useTranslation } from 'react-i18next';
import ShareableLinkDocumentsContext from 'router/subrouters/ShareableLink/providers/ShareableLinkDocuments/ShareableLinkDocuments.context';
import useMatchMedia from 'hooks/useMatchMedia';
import { Checkbox } from 'ncoded-component-library';

import './ShareableLinkDocumentsHeading.styles.scss';
import './ShareableLinkDocumentsHeading.styles.responsive.scss';

type ShareableLinkDocumentsHeadingProps = {
  className?: string;
};

const ShareableLinkDocumentsHeading: React.FC<
  ShareableLinkDocumentsHeadingProps
> = (props) => {
  const { className } = props;

  const {
    isSelectedMode,
    selected,
    isAllSelected,
    isEmptyOnThatLevel,
    selectAll,
    removeAll,
  } = useContext(ShareableLinkDocumentsContext);

  const { t } = useTranslation();

  const isPhablet = useMatchMedia('isPhablet');

  const {
    params: { sort },
    setQueryParam,
  } = useQueryParams();

  const updateSort = useCallback(
    (sort: string) => setQueryParam('sort', sort),
    [setQueryParam],
  );

  const classes = classNames('shareable-link-documents-heading', className);

  const onSelectAll = useCallback(() => {
    if (isAllSelected) removeAll();
    else selectAll();
  }, [isAllSelected, removeAll, selectAll]);

  if (isEmptyOnThatLevel) return null;

  return (
    <div className={classes}>
      <div>
        {isPhablet && isSelectedMode && (
          <Checkbox
            onChange={onSelectAll}
            checked={!!selected.length}
            className={classNames({ mixed: !isAllSelected })}
          />
        )}
        <SortingButton
          content={t('aToZ')}
          sortingValue="sortName"
          sort={sort}
          updateSort={updateSort}
        />
      </div>

      <div>
        <span>{t('size')}</span>

        <SortingButton
          content={t('modified')}
          sortingValue="modifiedAt"
          sort={sort}
          updateSort={updateSort}
        />

        <span style={{ width: '24px' }} />
      </div>
    </div>
  );
};

export default ShareableLinkDocumentsHeading;
